import React from 'react';
import styled from 'styled-components';
import { setStepAndStore } from '../../../utils/profileAssistantState';

const Button = styled.button`
  margin-top: 12px;
  padding: 4px 12px;
  background: #00aef7;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;

  &:hover {
    background: #0098d8;
  }
`;

const UserFocusStep = ({ profile, updateProfile, stepSetter }) => {
const handleUserFocusSelect = async (focus) => {
  try {
    console.log('🔄 Updating user focus for user ID:', profile?.u_id);
    console.log('🔍 Focus value:', focus);
    
    const requestBody = {
      userId: profile?.u_id,
      userFocus: focus
    };
    
    console.log('📤 Request payload:', JSON.stringify(requestBody, null, 2));
    
    const response = await fetch(`/api/profile/onboarding/user-focus`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(requestBody)
    });

    console.log('🔍 Response status:', response.status);
    
    if (!response.ok) {
      const errorText = await response.text();
      console.log('🔍 Error response body:', errorText);
      throw new Error(`Failed to update user focus: ${response.status} - ${errorText}`);
    }

    const updatedUser = await response.json();
    console.log('✅ User focus updated successfully:', updatedUser);

    // Update local state
    await updateProfile({ 
      ...profile, 
      u_customer_focus: focus 
    });

    const nextStep = 'askServiceDistance';

    // ✅ CRITICAL: Update onboarding stage to advance to next step
    const _tok = localStorage.getItem('token');
    await fetch(`/api/users/update-onboarding-stage`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...(_tok && { Authorization: `Bearer ${_tok}` }),
      },
      credentials: 'include',
      body: JSON.stringify({ u_onboarding_stage: nextStep }),
    });

    console.log('✅ Step advanced to:', nextStep);
    setStepAndStore(stepSetter, nextStep);

  } catch (err) {
    console.error('❌ Detailed error updating user focus:', err);
  }
};

  return (
    <>
      <div style={{ whiteSpace: 'pre-line', marginBottom: '10px' }}>
        {`You represent ${profile?.b_name}. Your company handles both business accounts and consumer accounts.\n\nWe would like to know if you, personally, handle Businesses, Consumers, or both for ${profile?.b_name}.`}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', marginTop: '4px' }}>
        <Button onClick={() => handleUserFocusSelect('B2B')}>Businesses Only</Button>
        <Button onClick={() => handleUserFocusSelect('B2C')}>Consumers Only</Button>
        <Button onClick={() => handleUserFocusSelect('B2BC')}>Both Businesses & Consumers</Button>
      </div>
    </>
  );
};

export default UserFocusStep;